<lib-subscription [withCertigna]="configuration.withCertigna" [configuration]="configuration"></lib-subscription>
